import { Injectable } from '@angular/core';

import { DataEntityField } from '@osos/shared/api';

import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { FieldPresenterModel } from '@osos/shared/types';
import { FieldParserV1Service } from '../../parsers/field-parser/field-parser-v1.service';

@Injectable()
export class FieldFactoryService extends FactoryBase<
  DataEntityField,
  FieldPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: FieldParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: FieldPresenterModel): DataEntityField {
    const parser = this.getParser(
      DataEntityField,
      FieldPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(model: DataEntityField): FieldPresenterModel {
    const parser = this.getParser(
      DataEntityField,
      FieldPresenterModel,
      model.specificationVersion || 1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
